import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Logo from './partials/Logo';
import FooterNav from './partials/FooterNav';
import FooterSocial from './partials/FooterSocial';

const domain = `https://www.cohorts.app`;

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool
}

const defaultProps = {
  topOuterDivider: false,
  topDivider: false
}

export const Footer = ({
  className,
  topOuterDivider,
  topDivider,
  ...props
}) => {

  const classes = classNames(
    'site-footer center-content-mobile',
    topOuterDivider && 'has-top-divider',
    className
  );

  return (
    <footer
      {...props}
      className={classes}
    >
      <div className="container">
        <div className={
          classNames(
            'site-footer-inner',
            topDivider && 'has-top-divider'
          )}>
          <span>
          <div className="footer-top space-between text-xxs">
            
          </div>
          <div className="footer-bottom space-between text-xxs">
            <FooterSocial />
            <div className="footer-copyright"><a href={`${domain}/reader/about`}>Reader</a></div>           
            <div className="footer-copyright"><a href={`${domain}/reader/terms`}>Terms</a></div>
            <div className="footer-copyright"><a href={`${domain}/reader/privacy`}>Privacy</a></div>
            <div className="footer-copyright"><a href={`${domain}/reader/blog`}>Blog</a></div>
            <div className="footer-copyright"><a href={`${domain}/reader/blog`}>User Guide</a></div>
            <div className="footer-copyright"><a href={`${domain}/reader/support`}>Support</a></div>
            <div className="footer-copyright">Made by <a href={`${domain}`}>Cohorts</a>.Copyright © 2020 Cohorts Software Applications Inc., All rights reserved.</div>
          </div>
          </span>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;
